import React from 'react';
import TopBar from '../Menu/TopBar';
import '../CSS/styles.css';

export default function AIWebsiteHTTrack() {
      
    return (
        <div style={{opacity: 1.0 }}>
            <TopBar/>
            <header>
                <h1>AI Websites - HTTrack</h1>
                <p></p>
            </header>            
            <main>
            </main>
        </div>
    )
}
